class NSSCartATCForm extends HTMLElement {
  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Cart ATC Form] Connected.`);

    this.querySelector(`[name="id"]`).style.display = `none`;

    this.initATCForm();
  }

  initATCForm() {

    // Option events
    const optionEls = this.querySelectorAll(`.nss-cart-atc-form__option`);

    optionEls.forEach((optionEl) => {

      optionEl.addEventListener(`mouseleave`, () => {
        optionEl.setAttribute(`nss-option-open`, false);
      })

      const selectedEl = optionEl.querySelector(`.nss-cart-atc-form__option-selected`);
      selectedEl.addEventListener(`click`, () => {
        if (optionEl.getAttribute(`nss-option-open`) == `true`) {
          optionEl.setAttribute(`nss-option-open`, false);
        } else {
          optionEl.setAttribute(`nss-option-open`, true);
        }
      });

      const valueEls = optionEl.querySelectorAll(`[nss-value]`);

      valueEls.forEach((valueEl) => {
        const buttonEl = valueEl.querySelector(`button`);
        buttonEl.addEventListener(`click`, () => {
          selectedEl.innerHTML = buttonEl.innerHTML;

          const string = selectedEl.querySelector(`span`).textContent;
          selectedEl.querySelector(`span`).textContent = `${string.substring(0, 27)}...`;

          optionEl.setAttribute(`nss-option-open`, false);
          optionEl.setAttribute(`nss-value`, valueEl.getAttribute(`nss-value`));
          valueEls.forEach((valueEl) => valueEl.setAttribute(`nss-selected`, false));
          valueEl.setAttribute(`nss-selected`, true);
          this.updateSelections();
        });
      });

    });
  }

  updateSelections() {
    const options = [];
    const optionEls = this.querySelectorAll(`.nss-cart-atc-form__option`);

    optionEls.forEach((optionEl) => {
      const group = [
        optionEl.getAttribute(`nss-position`),
        optionEl
      ];
      options.push(group);
    });

    options.sort((a, b) => a[0] - b[0]);

    let handle = ``;
    options.forEach((option) => {
      if (handle === ``) {
        handle = option[1].getAttribute(`nss-value`);
      } else {
        handle = `${handle}-${option[1].getAttribute(`nss-value`)}`;
      }
    });

    const productSelectEl = this.querySelector(`[name="id"]`);
    const selectOptionEl = productSelectEl.querySelector(`[nss-option-handle="${handle}"]`);
    productSelectEl.value = selectOptionEl.value;

    const optionCompare = selectOptionEl.getAttribute(`nss-option-compare-price`);
    const optionPrice = selectOptionEl.getAttribute(`nss-option-price`);

    // Update image
    const optionImage = selectOptionEl.getAttribute(`nss-option-image`);
    this.parentElement.parentElement.querySelector(`[nss-cart-image] img`).src = optionImage;

    // Update pricing
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', });
    const priceCompareEl = this.querySelector(`[nss-compare]`);
    const priceEl = this.querySelector(`[nss-price]`);

    priceCompareEl.innerHTML = formatter.format(optionCompare / 100);
    priceEl.innerHTML = formatter.format(optionPrice / 100);

    const savingsEl = this.querySelector(`[nss-savings]`);
    const savings = Math.round((optionCompare - optionPrice) / optionCompare * 100).toFixed(0);
    savingsEl.innerHTML = savings;

    // Update available
    const optionAvailable = selectOptionEl.getAttribute(`nss-option-available`);
    const buttonsEl = this.querySelector(`.nss-cart__buttons`);
    buttonsEl.setAttribute(`nss-available`, optionAvailable);
  }
}

let elementName = `nss-cart-atc-form`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSCartATCForm);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}
